import { c as _c } from "react/compiler-runtime";
import ReportsHero from "@/components/reports/ReportsHero";
import ReportExplorer from "@/components/reports/ReportExplorer";
import ResearchCTA from "@/components/home/ResearchCTA";
import SeoHead from "@/components/seo/SeoHead";
import { breadcrumbJsonLd, seoFromPage } from "@/lib/seo";
export default function ReportsPage() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = seoFromPage("reports");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const seo = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <><SeoHead {...seo} jsonLd={breadcrumbJsonLd([{
        name: "Home",
        path: "/"
      }, {
        name: "Reports",
        path: "/reports"
      }])} /><main><ReportsHero /><ReportExplorer /><ResearchCTA /></main></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}